export default "__VITE_ASSET__npGS7Hn1__"